import { Directive, HostListener, Input, Renderer2 } from '@angular/core';
import { FormlyField } from '@ngx-formly/core';

@Directive({
  selector: '[appManualFocus]',
})
export class ManualFocusDirective {
  @Input() field: FormlyField;

  constructor(private renderer: Renderer2) {}


  @HostListener('focusin', ['$event'])
  onFocusIn() {
    this.renderer.addClass((this.field as any).__formField__._elementRef.nativeElement, 'mat-focused');
  }

  @HostListener('focusout', ['$event'])
  onFocusOut() {
    this.renderer.removeClass((this.field as any).__formField__._elementRef.nativeElement, 'mat-focused');
  }

}
